/**
 * @flow
 * @format
 */

import _OpenDesignModal from './OpenDesignModal';

export default _OpenDesignModal;



// WEBPACK FOOTER //
// ./src/components/OpenDesignModal/index.js